import { Button } from '@mui/material';
import { Modal } from '@kathondvla/react-shared-components/src/components';
import { useState } from 'react';

import settings from '@config/settings';
import AddBoxIcon from '@mui/icons-material/AddBox';
import FileDropzone from '@UI/fileDropzone/FileDropzone';
import './addAttachmentModals.scss';

const AddFileModal = ({ onConfirm, onClose }) => {
  const [attachment, setAttachment] = useState(null);
  const fileLimit = attachment?.size && attachment.size > settings.hardcodings.fileLimitSize;
  const valid = attachment instanceof File && !fileLimit;

  const onAddHandler = () => {
    onConfirm?.({
      file: attachment,
      type: attachment.type || 'file',
      href: attachment.name,
      name: attachment.name,
      description: attachment.description || '',
      uploaded: false,
    });
  };

  return (
    <>
      <Modal.Header title="Een bijlage toevoegen" onClose={onClose} />
      
      <Modal.Body>
        <div className="add-attachment-modal">
          <section className="file-wrapper">
            <span className="label">Bestand selecteren:</span>
            <FileDropzone
              onFileSelect={setAttachment}
              selectedFile={attachment}
              maxSize={settings.hardcodings.fileLimitSize}
            />
          </section>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outlined" onClick={onClose}>
          Annuleren
        </Button>
        <Button
          variant="contained"
          startIcon={<AddBoxIcon />}
          disabled={!valid}
          onClick={onAddHandler}
        >
          Voeg toe
        </Button>
      </Modal.Footer>
    </>
  );
};

export default AddFileModal;